/* Anonymous consultation attribution. No names, email, or question text. */
(()=>{
 const url=new URL(location.href),token=url.searchParams.get('ff_ref');
 if(!token||!/^([0-9a-f-]{36})\.(\d{13})\.([0-9a-f]{64})$/.test(token))return;
 const issued=Number(token.split('.')[1]);if(issued>Date.now()+60000||Date.now()-issued>30*86400000)return;
 let pending=false,saved=false,attempts=0;
 const save=async()=>{
  if(pending||saved||attempts>=3||window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===false)return;
  pending=true;attempts++;
  try{
   const root=window.Shopify?.routes?.root||'/';
   const response=await fetch(root+'cart/update.js',{method:'POST',credentials:'same-origin',keepalive:true,headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{__fabric_finder_ref:token}})});
   if(!response.ok)throw Error('attribution_cart_update');
   saved=true;
   const current=new URL(location.href);
   if(current.searchParams.get('ff_ref')===token){current.searchParams.delete('ff_ref');history.replaceState(history.state,'',current.pathname+current.search+current.hash);}
  }catch{
   if(attempts<3)setTimeout(save,attempts*1000);
  }finally{pending=false;}
 };
 save();
 document.addEventListener('visitorConsentCollected',save);
 window.addEventListener('online',save);
})();
